import { FAMILY_OFFER } from "../../../shared/magic-letter-box";
import { MagicLetterBoxLink } from "./MagicLetterBoxLink";

export default function FamilyMembership({ source, title = "One letter is a lovely start. Keep the story going." }: { source: string; title?: string }) {
  return (
    <section aria-label="The Magic Letter Box Family membership" className="rounded-2xl border border-elfGreen/30 bg-elfGreen-light/40 p-6 md:p-8">
      <p className="mb-2 text-sm font-semibold uppercase tracking-wide text-elfGreen-ink">The Magic Letter Box · Family membership</p>
      <h2 className="mb-3 text-2xl font-bold md:text-3xl">{title}</h2>
      <p className="mb-4 max-w-2xl text-slate-700">From your elf&apos;s next adventure to Santa&apos;s Christmas note, a lost tooth, or a birthday: create a personal letter for each new moment.</p>
      <ul className="mb-6 grid gap-2 text-sm text-slate-800 sm:grid-cols-2">
        <li>Unlimited letters with the Family plan</li>
        <li>Premium letterhead templates</li>
        <li>Up to {FAMILY_OFFER.children} children</li>
        <li>Saved letter history and PDF downloads</li>
      </ul>
      <p className="mb-4 text-lg font-semibold">Family is {FAMILY_OFFER.price}. Start with {FAMILY_OFFER.trialLetters} free letters.</p>
      <MagicLetterBoxLink source={source}>Continue at The Magic Letter Box</MagicLetterBoxLink>
      <p className="mt-3 text-xs leading-relaxed text-slate-600">A separate account at The Magic Letter Box is required. No credit card is needed for the trial. Your Elf Letter Bot letters do not transfer automatically.</p>
    </section>
  );
}
